/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { array, func, number } from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import css from './LineItems.module.css';
import { formatMoney } from '../../../util/currency';
const {
  LINE_ITEM_ADULT_HUNTER,
  LINE_ITEM_ADULT_NON_HUNTER,
  LINE_ITEM_YOUTH_HUNTER,
  LINE_ITEM_YOUTH_NON_HUNTER,
} = require('../../../shared/transaction');

const LineItemFlexiblePricing = props => {
  const { lineItems, onClick, intl } = props;

  const getLineItemLabel = (code, price, dayCount, quantity) => {
    const quantityNum = typeof quantity === 'object' ? quantity.toNumber() : quantity;
    switch (code) {
      case LINE_ITEM_ADULT_HUNTER:
        return (
          <FormattedMessage
            id="LineItemFlexiblePricing.adultHunterLabel"
            values={{ price, count: quantityNum, dayCount }}
          />
        );
      case LINE_ITEM_ADULT_NON_HUNTER:
        return (
          <FormattedMessage
            id="LineItemFlexiblePricing.adultNonHunterLabel"
            values={{ price, count: quantityNum, dayCount }}
          />
        );
      case LINE_ITEM_YOUTH_HUNTER:
        return (
          <FormattedMessage
            id="LineItemFlexiblePricing.youthHunterLabel"
            values={{ price, count: quantityNum, dayCount }}
          />
        );
      case LINE_ITEM_YOUTH_NON_HUNTER:
        return (
          <FormattedMessage
            id="LineItemFlexiblePricing.youthNonHunterLabel"
            values={{ price, count: quantityNum, dayCount }}
          />
        );
      default:
        return code;
    }
  };

  return lineItems?.map((lineItem, index) => {
    const price = formatMoney(intl, lineItem.lineItem.unitPrice);

    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={`${lineItem.lineItem.code}-${index}`} className={css.lineItem}>
        <span className={css.itemLabel} onClick={onClick} role="button" tabIndex="0">
          {getLineItemLabel(
            lineItem.lineItem.code,
            price,
            lineItem.dayCount,
            lineItem.itemQuantity
          )}
        </span>
        <span className={css.itemValue}>{lineItem.formattedPackageTotal}</span>
      </div>
    );
  });
};

LineItemFlexiblePricing.propTypes = {
  lineItems: array.isRequired,
  onClick: func.isRequired,
  dayCount: number.isRequired,
};

export default injectIntl(LineItemFlexiblePricing);
